module.exports = (($) => {
    class AjaxHandler {}
    $(document).ajaxError(function(event, jqxhr, settings, thrownError) {
        // not allowed
        if (jqxhr.status == 403) {
            // @todo display a "BOX" with this message
            alert(jqxhr.responseJSON.message);
        }
        // not authenticated
        if (jqxhr.status == 401) {
            // redirect home to login form
            window.location.href = '/';
        }
        // not found
        if (jqxhr.status == 404) {
            alert(jqxhr.responseJSON.message);
        }

        // csrf mismacht
        if (jqxhr.status == 419) {
            // redirect home to login form
            alert('Anfrage ungültig / Laden Sie die Seite neu und probieren Sie es noch einmal.');
        }
        // error
        if (jqxhr.status == 500 || jqxhr.status == 503) {
            if (jqxhr.responseJSON != undefined && jqxhr.responseJSON.message != undefined) {
                alert(jqxhr.responseJSON.message);
            } else {
                alert('Unerwartete Server Antwort / Verbindungsfehler - Bitte noch einmal versuchen.');
            }
        }
    });
    $(document).ajaxComplete(function(event, request) {
        responseVersion = parseInt(request.getResponseHeader('ity-version'));
        bodyVersion = parseInt($('html').attr('ity-version'));
        if (responseVersion && responseVersion > bodyVersion) {
            $('#ity-browser-reload-msg').show('slow');
        }

        // only for STRATO Hosting and random 503 responses
        if (request.responseText && request.responseText.includes("<title>503 Service Unavailable</title>")) {
            alert('503 Service Unavailable - Unerwartete Server Antwort / Verbindungsfehler - Bitte noch einmal versuchen. ');
        }
    });
    return AjaxHandler
})(jQuery)
